import React, { useEffect, useContext } from "react";
import useState from "react-usestateref";
import Logo from "../assests/Logo.webp";
import authService, { verifyAuth } from "../services/authservices";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { ScaleLoader } from "react-spinners";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import Menu from "@material-ui/core/Menu";
import { Link, useNavigate, useLocation } from "react-router-dom";
import UserIcon from "../assests/icons/profile.png";
import { UserContext } from "../contexts/UserContext";
import { Tooltip } from "react-tooltip";
import { getUserDetails } from "../services/authservices";
import Joyride from "react-joyride";
// import { useAppKit } from '@reown/appkit/react';
// import {
//   useWeb3Modal,
//   useWeb3ModalAccount,
//   useWeb3ModalProvider,
// } from "@web3modal/ethers/react";
// import {
//   BrowserProvider,
//   Contract,
//   formatUnits,
//   JsonRpcProvider,
// } from "ethers";
// import { ethers } from "ethers";
// import Web3 from "web3";

dayjs.extend(relativeTime);
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },

  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [NotiEl, setNotiEl] = useState(null);
  const isHomePage = window.location.pathname === "/";
  const istermsCondition = window.location.pathname === "/termscondition";
  const isprivacypolicy = window.location.pathname === "/privacypolicy";
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { login } = useContext(UserContext);
  const [toastVisible, setToastVisible] = useState(false);
  const navigate = useNavigate();

  const [loginCheck, setloginCheck] = useState(false);
  const [activeLink, setActiveLink] = useState("");
  const isActiatedFree = localStorage.getItem("freemiumActivated") || "false";
  const { theme, toggleTheme } = useContext(UserContext);
  const location = useLocation();
  const classes = useStyles();
  const { logout } = useContext(UserContext);
  const [hasUnread, setHasUnread] = useState(false);
  const [user, setUser] = useState({
    tfaStatus: 0,
    email: null,
    emailStatus: 0,
    uid: null,
    referralCode: null,
    referralUrl: null,
    displayname: null,
    country: null,
    isAuthenticated: false,
    botStatus: "DeActive",
    profile_image: "",
  });

  const walletneed = async () => {
    try {
      if (!toastVisible) {
        setToastVisible(true); // Set toast as visible
        toast.warn(
          <div className="toast-ml">
            <h4 className="toast-title">Oops!</h4>
            <p className="toast-message">{"Connect Wallet to continue!"}</p>
          </div>,
          {
            onClose: () => setToastVisible(false), // Reset toastVisible on close
            autoClose: 3000, // Optional: auto-close after 3 seconds
          }
        );
      }
    } catch (error) {
      console.log(error, "0000000000000000");
    }
  };

  const [run, setRun] = useState(false);
  const [emailPopup, setEmailPopup] = useState(false);
  const [verifyEmailPopup, setVerifyEmailPopup] = useState(false);
  const [userVerifyEmail, setuserVerifyEmail, userVerifyEmailref] = useState(1);
  const [headerLoader, setheaderLoader, headerLoaderref] = useState(true);
  const [notificationPopup, setnotificationPopup] = useState(false);
  const fetchUserDetails = async () => {
    console.log("000000000000000077777");
    setheaderLoader(true);
    const token = localStorage.getItem("token");
    if (token) {
      setUser({
        isAuthenticated: true,
      });
      setheaderLoader(false);
      console.log(user.isAuthenticated, "user.isAuthenticated");
      try {
        const data = await getUserDetails(token);
        if (data && data.status) {
          const userDetails = {
            isAuthenticated: true,
            tfaStatus: data.tfastatus,
            emailStatus: data.emailStatus,
            email: data.email,
            displayname: data.displayname,
            country: data.country,
            uid: data.uid,
            referralCode: data.referralCode,
            referralUrl: data.referralUrl,
            botStatus: data.botStatus,
            profile_image: data.profile_image,
          };
          setUser(userDetails);
          setuserVerifyEmail(data.emailStatus);
          console.log(
            data,
            "Home response here ---->>>>>",
            userVerifyEmailref.current
          );
          const hasSeenPopup = localStorage.getItem("hasSeenEmailPopup");
          const hasSeenVerifyPopup = localStorage.getItem(
            "hasSeenEmailVerifyPopup"
          );
          console.log(
            hasSeenVerifyPopup,
            hasSeenPopup,
            "hasSeenVerifyPopup hasSeenPopup data.emailStatus",
            data.emailStatus
          );
          const userLogin = localStorage.getItem("userlogin");
          if (userLogin === "true") {
            setRun(true);
          } else {
            if (!userDetails?.email || userDetails?.email == "N/A") {
              if (token && !hasSeenPopup) {
                setEmailPopup(true);
                // localStorage.setItem("hasSeenEmailPopup", "true"); // Mark popup as shown
              }
            } else if (
              data.emailStatus == 0 &&
              !hasSeenVerifyPopup &&
              location.pathname === "/home"
            ) {
              setVerifyEmailPopup(true);
              sessionStorage.setItem("hasSeenEmailVerifyPopup", "true");
            }
          }
        } else {
          setheaderLoader(false);

          setUser({
            isAuthenticated: false,
            tfaStatus: 0,
            email: null,
            uid: null,
            referralCode: null,
            referralUrl: null,
            botStatus: "DeActive",
            profile_image: null,
          });
        }
      } catch (error) {
        setheaderLoader(false);

        console.error("Error fetching user details:", error);
        setUser({
          isAuthenticated: false,
          tfaStatus: 0,
          email: null,
          uid: null,
          referralCode: null,
          referralUrl: null,
          botStatus: "DeActive",
          profile_image: null,
        });
      }
    } else {
      setheaderLoader(false);
      setUser({
        isAuthenticated: false,
        tfaStatus: 0,
        email: null,
        uid: null,
        referralCode: null,
        referralUrl: null,
        botStatus: "DeActive",
        profile_image: null,
      });
    }
    setLoading(false);
    setheaderLoader(false);
  };
  console.log(headerLoader, headerLoaderref.current, "headerLoader");

  const closePopup = () => {
    setEmailPopup(false);
  };

  const closeVerifyPopup = () => {
    setVerifyEmailPopup(false);
  };
  useEffect(() => {
    if (location.pathname !== "/home") {
      setVerifyEmailPopup(false);
    }
  }, [location.pathname]);

  const proceedToProfile = () => {
    setEmailPopup(false);
    navigate("/profile");
    localStorage.setItem("hasSeenEmailPopup", "true");
    localStorage.setItem("hasSeenEmailVerifyPopup", "true");
  };

  const close_popup = () => {
    setnotificationPopup(false);
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    console.log(userToken, "userToken");
    if (userToken == null || userToken == "" || userToken == undefined) {
      setheaderLoader(false);
    } else {
      checkuserAuth();
    }
  }, [0]);

  const container =
    window !== undefined ? () => window().document.body : undefined;

  // const { chainId, isConnected } = useWeb3ModalAccount();

  // const { open, close } = useWeb3Modal();
  // const { open } = useAppKit()
  // const { disconnect } = useDisconnect();
  // const { walletProvider } = useWeb3ModalProvider();

  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isConnectedBoo, setisConnected, isConnectedBooref] = useState(false);
  const [validWallet, setValidWallet] = useState(false);

  const [openpopup, setOpenpopup] = useState(false);
  const handleOpen = () => setOpen(true);

  const showErrorToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Error!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const showSuccessToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true);
      toast.success(
        <div className="toast-ml">
          <h4 className="toast-title">Success!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset state on close
          autoClose: 3000, // Auto-close after 3 seconds
        }
      );
    }
  };

  const showWarningToast = (message) => {
    if (!toastVisible) {
      setToastVisible(true); // Set toast as visible
      toast.error(
        <div className="toast-ml">
          <h4 className="toast-title">Oops!</h4>
          <p className="toast-message">{message}</p>
        </div>,
        {
          onClose: () => setToastVisible(false), // Reset toastVisible on close
          autoClose: 3000, // Optional: auto-close after 3 seconds
        }
      );
    }
  };

  const BSC_TESTNET_CHAIN_ID = 97;

  const [dropstatus, setdropstatus] = useState(false);

  const dropdowns = async () => {
    console.log(dropstatus, "dropstatus");
    if (dropstatus == true) {
      setdropstatus(false);
    } else {
      setdropstatus(true);
    }
  };

  const checkuserAuth = async () => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const data = await verifyAuth(token);
        console.log("token verify data --->>", data);
        if (data.status === 401 || data.Message === "TokenExpired") {
          handleLogout();
          // await disconnect();
          showerrorToastExpired(
            <div className="toast-ml">
              <h4 className="toast-title">Error!</h4>
              <p className="toast-message">
                Session expired. Please log in again.
              </p>
            </div>
          );
        } else {
          // console.log("Token is valid");
        }
      } catch (error) {
        // console.error("Error auth user details:", error);
        handleLogout();
      }
    }
  };

  useEffect(() => {
    document.body.classList.add(theme); // Apply the current theme to the body element (or another container)
  }, [theme]);

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    console.log("----uuuuu", userToken);

    if (userToken == null || userToken == "" || userToken == undefined) {
      setheaderLoader(false);
    } else {
      console.log("----", userToken);
      setUser({
        isAuthenticated: true,
      });
      fetchUserDetails();
      getnotify();
    }
  }, []);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClose1 = () => {
    setNotiEl(null);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const getnotify = async () => {
    try {
      const response = await authService.getNotification();
      console.log("response-->", response.data);
      if (response.status) {
        setLoginHistory(response.data.data.data);
        const hasUnreadNotifications = response.data.data.data.some(
          (n) => n.status === 0
        );
        //  console.log("hasUnreadNotifications--->>>>",hasUnreadNotifications);
        setHasUnread(hasUnreadNotifications); // Update state

        const hasadminNotifications =
          response.data.data.admin_notification.some(
            (n) => n.status === 0 && n.admin_status === 1
          );

        if (hasadminNotifications) {
          setnotificationPopup(true);
          setAdminNotification(response.data.data.admin_notification[0]);
          console.log(
            "hasadminNotifications--->>>>",
            AdminNotificationref.current
          );
        }
      }
    } catch (error) {}
  };

  const handleClick1 = async (event) => {
    setNotiEl(event.currentTarget);
    const response = await authService.notifyStateChange();
    if (response.status) {
      setHasUnread(false); // Remove the bell indicator
      getnotify();
    }
  };

  // const handleThemeToggle = () => {
  //   // window.location.reload();
  //   setTheme((prevTheme) => {
  //     const newTheme = prevTheme === "dark" ? "light" : "dark";
  //     localStorage.setItem("theme", newTheme); // Save to localStorage for persistence
  //     return newTheme;
  //   });
  // };

  useEffect(() => {
    // Whenever the theme is toggled, we update the body class.
    // This ensures the theme change is applied globally on the page.
    document.body.className = theme; // Update body class according to the theme
  }, [theme]);

  // useEffect(() => {
  //   document.body.setAttribute("data-theme", theme); // Set the theme attribute on <body>
  // }, [theme]);
  // useEffect(() => {
  //   if (theme === 'dark') {
  //     document.body.classList.add('dark');
  //     document.body.classList.remove('light');
  //   } else {
  //     document.body.classList.add('light');
  //     document.body.classList.remove('dark');
  //   }
  //   localStorage.setItem('theme', theme);
  // }, [theme])

  useEffect(() => {
    let userToken = sessionStorage.getItem("user_token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setheaderLoader(false);
      setloginCheck(false);
    }
  }, []);

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
  };

  const obfuscateEmail = (email) => {
    if (!email) return "";
    const [localPart, domainPart] = email.split("@");
    const firstFive = localPart.slice(0, 3);
    return `${firstFive}***@${domainPart}`;
  };

  const [open1, setOpen] = useState(false);

  const notifyNav = () => {
    navigate("/history");
  };
  const copyToClipboard = (() => {
    let toastVisible = false;
    let timeout = null;

    return (text) => {
      if (toastVisible) return;

      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(() => {
        navigator.clipboard
          .writeText(text)
          .then(() => {
            toastVisible = true;
            toast.success(
              <div className="toast-ml">
                <h4 className="toast-title">Success!</h4>
                <p className="toast-message">UID code Copied!</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false;
                },
              }
            );
          })
          .catch((err) => {
            console.error("Failed to copy text:", err);
            toastVisible = true;
            toast.error(
              <div className="toast-ml">
                <h4 className="toast-title">Error!</h4>
                <p className="toast-message">Failed to copy code</p>
              </div>,
              {
                onClose: () => {
                  toastVisible = false;
                },
              }
            );
          });
      }, 300);
    };
  })();

  const handleLogout = async () => {
    await logout();
    localStorage.clear();
    navigate("/");
    setheaderLoader(false);
    user.isAuthenticated = false;
    // toast.error("Logout Successfully!");
    // window.location.reload();
    toast.dismiss();
    // showSuccessToast("Wallet Disconnected");
  };

  const [loginHistory, setLoginHistory, loginHistoryref] = useState([]);
  const [AdminNotification, setAdminNotification, AdminNotificationref] =
    useState([]);
  const handleLogin = () => {
    navigate("/login");
  };
  const handleRegister = () => {
    navigate("/register");
  };

  const showerrorToastExpired = (message) => {
    toast.dismiss();
    toast.error(message);
  };

  // useEffect(() => {
  //   const fetchLoginHistory = async () => {
  //     const response = await authService.getLoginHistory();
  //     if (response.status) {
  //       setLoginHistory(response.data.slice(0, 5)); // Limit to 5 records
  //     } else {
  //       console.error("Failed to fetch login history:", response.Message);
  //     }
  //     setLoading(false);
  //   };

  //   fetchLoginHistory();
  // }, []);

  const truncateText = (text, maxLength) => {
    if (!text || typeof text !== "string") {
      return "--";
    }
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };

  const steps = [
    {
      target: ".home-link",
      content: (
        <div>
          <h3>Create Account</h3>
          <p>
            Get started by creating your account in just a few clicks using your
            email.
          </p>
        </div>
      ),
      placement: "bottom",
      disableBeacon: true,
      spotlightClicks: false,
      disableOverlayClose: true,
    },
    {
      target: ".deposit-link",
      content: (
        <div>
          <h3>Deposit Amount</h3>
          <p>
            Securely fund your wallet with crypto and prepare for automated
            trading.
          </p>
        </div>
      ),
      placement: "bottom",
    },
    {
      target: ".upgrade-link",
      content: (
        <div>
          <h3>Plan Upgrade</h3>
          <p>
            User has the opportunity to renew his plan either for free or for a
            cost.
          </p>
        </div>
      ),
      placement: "bottom",
    },
    {
      target: ".apibind-link",
      content: (
        <div>
          <h3> Enable Exchange</h3>
          <p>
            Connect your preferred exchange by adding your API and secret keys.
          </p>
        </div>
      ),
      placement: "bottom",
    },
    {
      target: ".bottrade-link",
      content: (
        <div>
          <h3> Activate Bot</h3>
          <p>
            Turn on your trading bot, manage your portfolio, and let it work for
            you.
          </p>
        </div>
      ),
      placement: "bottom",
    },
    {
      target: ".withdraw-link",
      content: (
        <div>
          <h3>Withdraw Profits</h3>
          <p>
            Seamlessly transfer your profits anytime with a few simple steps.
          </p>
        </div>
      ),
      placement: "bottom",
    },
  ];

  return (
    <div>
      <header className="scrolled">
        <div>
          <div className={`${classes.root} `}>
            <AppBar position="static">
              <Toolbar className="container-fluid pad-0 w-100">
                <Typography variant="h6" className={classes.title}>
                  <div className="d-flex">
                    <Link to="/" className="logo-brand">
                      <img src={Logo} className="img-fluid" alt="logo" />
                    </Link>
                    <div className={`menu_new_typr ${classes.appBarItems}`}>
                      {/* <Link to="/" color="inherit" className="contact_button"> */}
                      {/* {user.isAuthenticated ? ( */}
                      <Link
                        to={user.isAuthenticated ? "/home" : "/login"}
                        color="inherit"
                        className={`${isActive("home")} home-link`}
                      >
                        Home
                      </Link>
                      {/* ) : (
                        <Link
                          onClick={walletneed}
                          to={user.isAuthenticated ? "/" : "/"}
                        >
                          Home
                        </Link>
                      )} */}

                      <Link
                        to={user.isAuthenticated ? "/deposit" : "/login"}
                        color="inherit"
                        className={`${isActive("deposit")} deposit-link`}
                      >
                        Deposit
                      </Link>

                      <Link
                        to={user.isAuthenticated ? "/withdraw" : "/login"}
                        color="inherit"
                        className={`${isActive("withdraw")} withdraw-link`}
                      >
                        Withdraw
                      </Link>

                      {/* <Link
                        to={user.isAuthenticated ? "/strategies" : "/login"}
                        color="inherit"
                        className={`${isActive("strategies")} withdraw-link`}
                      >
                        Strategies
                      </Link> */}
                      <Link
                        to={user.isAuthenticated ? "/transferwallet" : "/login"}
                        color="inherit"
                        className={`${isActive("transferwallet")}`}
                      >
                        Transfer
                      </Link>

                      <Link
                        to={user.isAuthenticated ? "/upgrade" : "/login"}
                        color="inherit"
                        className={`${isActive("upgrade")} upgrade-link`}
                      >
                        Upgrade
                      </Link>

                      <Link
                        to={user.isAuthenticated ? "/apibind" : "/login"}
                        color="inherit"
                        className={`${isActive("apibind")} apibind-link`}
                      >
                        API Binding
                      </Link>

                      <Link
                        to={
                          user.isAuthenticated ? "/bottradehistory" : "/login"
                        }
                        color="inherit"
                        className={`${isActive(
                          "bottradehistory"
                        )} bottrade-link`}
                      >
                        Bot Trade
                      </Link>

                      <Link
                        to={
                          user.isAuthenticated ? "/balance-history" : "/login"
                        }
                        color="inherit"
                        className={`${isActive("balance-history")}`}
                      >
                        Bot Balance
                      </Link>

                      <Link
                        to={user.isAuthenticated ? "/referral" : "/login"}
                        color="inherit"
                        className={`${isActive("referral")}`}
                      >
                        Refer & Earn
                      </Link>
                    </div>
                  </div>
                </Typography>
                <div className="mobile_change_header">
                  <div className="mobile-theme-icon">
                    {/* {theme == "dark" ? (
                    <Link
                      onClick={handleThemeToggle}
                      aclassName="contact_button"
                    >
                      <span className="theme-icons">
                        {" "}
                        <i clss="bi bi-brightness-high"></i>
                      </span>
                    </Link>
                  ) : (
                    <Link
                      onClick={handleThemeToggle}
                      className="contact_button"
                    >
                      <span className="theme-icons">
                        <i class="bi bi-moon"></i>
                      </span>
                    </Link>
                  )} */}

                    {/* {theme === "dark" ? (
                      <Link onClick={toggleTheme} className="contact_button">
                        <span className="theme-icons">
                          <i className="bi bi-brightness-high"></i>
                        </span>
                      </Link>
                    ) : (
                      <Link onClick={toggleTheme} className="contact_button">
                        <span className="theme-icons">
                          <i className="bi bi-moon"></i>
                        </span>
                      </Link>
                    )} */}
                  </div>
                  {user.isAuthenticated ? (
                    <div className="mobile-only">
                      <h6
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        className="head-drops cursor-pointer"
                        onClick={handleClick1}
                      >
                        <img
                          src={require("../assests/icons/Notification.png")}
                          width="30px"
                          className="dark_display_none nav-primary-icons"
                        />
                        {hasUnread && <div className="bell-indicator"></div>}
                      </h6>
                      <Menu
                        id="simple-menu"
                        anchorEl={NotiEl}
                        keepMounted
                        open={Boolean(NotiEl)}
                        onClose={handleClose1}
                        className="MuiList-padding-notify"
                      >
                        <div className="frame-container notify-dropdown">
                          <div className="user-details-noti">
                            <div className="notify-contents">
                              <div className="notify-head-wrapper d-flex align-items-center justify-content-between w-100">
                                <h5>Notifications</h5>
                                <div
                                  className="d-flex align-items-center gap-2 cursor-pointer"
                                  onClick={notifyNav}
                                >
                                  <span className="home_starty_view">
                                    View All
                                  </span>
                                  <i className="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="noti_drop_margin">
                            {loading ? (
                              <div className="loader_main loader_mainChange">
                                <ScaleLoader
                                  color="#20A1FD"
                                  height={10}
                                  width={3}
                                />
                                <p>Loading...</p>
                              </div>
                            ) : (
                              loginHistoryref.current.map((login, index) => (
                                <div
                                  key={index}
                                  className="d-flex align-items-center justify-content-between my-2 py-2"
                                >
                                  <span className="top_startgy_inbottomadvance">
                                    {/* {truncateText(,18)} */}
                                    {truncateText(login.message, 18)}
                                    {/* {login.message} */}
                                  </span>
                                  <span className="noti_inner_right">
                                    {dayjs(login.createdAt).fromNow()}
                                  </span>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </Menu>
                    </div>
                  ) : null}

                  <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="menu"
                    className={` m-0 p-0 ${classes.mobileMenuButton} ${classes.drawerIcon}`}
                  >
                    <MenuIcon className="meus" onClick={handleMobileMenuOpen} />
                  </IconButton>
                </div>
                {headerLoader == true ? (
                  ""
                ) : (
                  <div className={`menu_new_typr_right ${classes.appBarItems}`}>
                    {!user.isAuthenticated ? (
                      <>
                        <Link to="/login">
                          <button
                            className="head-btn-login now_log"
                            style={{ width: "120px" }}
                          >
                            <span className="head-btn-login-now now_log">
                              Login
                            </span>
                            <span className="head-btn-login-new">Login</span>
                          </button>
                        </Link>
                        <Link to="/register">
                          <button
                            className="head-btn-login resp_100"
                            style={{ width: "120px" }}
                          >
                            <span className="head-btn-login-now">Register</span>
                            <span className="head-btn-login-new">Register</span>
                          </button>
                        </Link>
                      </>
                    ) : (
                      <>
                        <h6
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          className=" head-drops cursor-pointer"
                          onClick={handleClick1}
                        >
                          {/* {loginCheck ? ( */}
                          <img
                            src={require("../assests/icons/Notification.png")}
                            width="30px"
                            className="dark_display_none nav-primary-icons"
                          />
                          {hasUnread && <div className="bell-indicator"></div>}
                        </h6>
                        <Menu
                          id="simple-menu"
                          anchorEl={NotiEl}
                          keepMounted
                          open={Boolean(NotiEl)}
                          onClose={handleClose1}
                          className="MuiList-padding-notify"
                        >
                          {/* {loginCheck ? ( */}
                          <div className="frame-container notify-dropdown">
                            {/* user details */}
                            <div className="user-details-noti">
                              <div className="notify-contents">
                                <div className="notify-head-wrapper d-flex align-items-center justify-content-between w-100">
                                  <h5>Notifications</h5>
                                  <div
                                    className="d-flex align-items-center gap-2 cursor-pointer mt-3"
                                    onClick={notifyNav}
                                  >
                                    <span className="home_starty_view">
                                      View All
                                    </span>
                                    <i class="fa-solid fa-chevron-right home_starty_viewarrow"></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="noti_drop_margin">
                              {loading ? (
                                <div className="loader_main loader_mainChange">
                                  <ScaleLoader
                                    color="#20A1FD"
                                    height={10}
                                    width={3}
                                  />
                                  <p>Loading...</p>
                                </div>
                              ) : (
                                loginHistoryref.current.map((login, index) => (
                                  <div
                                    key={index}
                                    className="d-flex align-items-center justify-content-between my-2 py-2"
                                  >
                                    <span className="top_startgy_inbottomadvance">
                                      {login.message}
                                    </span>
                                    <span className="noti_inner_right">
                                      {dayjs(login.createdAt).fromNow()}
                                    </span>
                                  </div>
                                ))
                              )}
                            </div>
                          </div>
                          {/* ) : (
                        ""
                      )} */}
                        </Menu>
                        <h6
                          aria-controls="simple-menu"
                          aria-haspopup="true"
                          className=" head-drops cursor-pointer"
                          onClick={handleClick}
                        >
                          {/* {loginCheck ? ( */}
                          <img
                            src={require("../assests/icons/profile.png")}
                            width="30px"
                            className="dark_display_none nav-primary-icons"
                          />
                        </h6>

                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                          className="MuiList-padding"
                        >
                          {/* {loginCheck ? ( */}
                          <div className="frame-container">
                            {/* user details */}
                            <div className="user-details">
                              {user.profile_image != null &&
                              user.profile_image != undefined &&
                              user.profile_image != "" ? (
                                <img
                                  src={user.profile_image}
                                  alt="usericon"
                                  className="user-img"
                                />
                              ) : (
                                <img
                                  src={require("../assests/icons/home-user.png")}
                                  alt="usericon"
                                  className="user-img"
                                />
                              )}
                              <div className="details">
                                <span className="details-mail">
                                  {user.email}
                                </span>
                                <span className="details-udi">
                                  UID: {user.uid}
                                  <i
                                    className="fa-regular fa-copy cursor-pointer"
                                    onClick={() => copyToClipboard(user.uid)}
                                    style={{
                                      color: "#20A1FD",
                                    }}
                                  ></i>
                                </span>
                              </div>
                            </div>
                            {/* links */}
                            <ul className="links">
                              <li>
                                <Link to="/profile" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/icons/user-icon.png")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span>Profile</span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/deposit" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/icons/deposit-icon.png")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span>Deposit</span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/withdraw" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/icons/withdraw-icon.png")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span className="hover">Withdraw</span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="/transferwallet"
                                  className="link-content"
                                >
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/transfer.webp")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span className="hover">Transfer</span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>

                              {isActiatedFree === "false" && (
                                <li>
                                  <Link to="/apibind" className="link-content">
                                    <div className="head_link_flex">
                                      <img
                                        src={require("../assests/icons/api-bind.png")}
                                        // width="30px"
                                        className="nav-primary-icons-headinner"
                                      />
                                      <span>API Bind</span>
                                    </div>
                                    <span className="text_head_arrow hover-show">
                                      <i class="fa-solid fa-chevron-right"></i>
                                    </span>
                                  </Link>
                                </li>
                              )}
                              <li>
                                <Link to="/upgrade" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/upgrade.webp")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span>Upgrade </span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/upgrade" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/upgrade.webp")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span>Bot Trade History </span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>

                              <li>
                                <Link to="/strategies" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/startegy-icon.png")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span>Strategies </span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>

                              {/* <li>
                              <Link to="/team" className="link-content">
                                <div className="head_link_flex">
                                  <img
                                    src={require("../assests/icons/team-ico.png")}
                                    // width="30px"
                                    className="nav-primary-icons-headinner"
                                  />
                                  <span>Your Team</span>
                                </div>
                                <span className="text_head_arrow hover-show">
                                  <i class="fa-solid fa-chevron-right"></i>
                                </span>
                              </Link>
                            </li> */}

                              {/* <li>
                              <Link to="/poolhistory" className="link-content">
                                <div className="head_link_flex">
                                  <img
                                    src={require("../assests/icons/team-ico.png")}
                                    // width="30px"
                                    className="nav-primary-icons-headinner"
                                  />
                                  <span>Pool Progress</span>
                                </div>
                                <span className="text_head_arrow hover-show">
                                  <i class="fa-solid fa-chevron-right"></i>
                                </span>
                              </Link>
                            </li> */}
                              <li>
                                <Link to="/security" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/icons/Security-icon.png")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span>Security</span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>
                              <li>
                                <Link to="/faq" className="link-content">
                                  <div className="head_link_flex">
                                    <img
                                      src={require("../assests/icons/question-icon.png")}
                                      // width="30px"
                                      className="nav-primary-icons-headinner"
                                    />
                                    <span> FAQs</span>
                                  </div>
                                  <span className="text_head_arrow hover-show">
                                    <i class="fa-solid fa-chevron-right"></i>
                                  </span>
                                </Link>
                              </li>
                              {/* <li>
                              <Link to="/policy" className="link-content">
                                <div className="head_link_flex">
                                  <img
                                    src={require("../assests/icons/policy-icon.png")}
                                    // width="30px"
                                    className="nav-primary-icons-headinner"
                                  />
                                  <span> Policy</span>
                                </div>
                                <span className="text_head_arrow hover-show">
                                  <i class="fa-solid fa-chevron-right"></i>
                                </span>
                              </Link>
                            </li> */}
                            </ul>
                            {/* logout button */}
                            {user.isAuthenticated && (
                              <div
                                className="btn-wrapper security-link cursor-pointer"
                                onClick={() => {
                                  // disconnect();
                                  handleLogout();
                                }}
                              >
                                <span className="user-btn">Logout</span>
                                <img
                                  src={require("../assests/logout.png")}
                                  alt="logoutimg"
                                  className="logout-img"
                                />
                              </div>
                            )}
                          </div>
                        </Menu>
                      </>
                    )}

                    {/* {theme === "dark" ? (
                    <Link onClick={toggleTheme} className="contact_button">
                      <span className="theme-icons">
                        <i className="bi bi-brightness-high"></i>{" "}
                        Icon for light mode
                      </span>
                    </Link>
                  ) : (
                    <Link onClick={toggleTheme} className="contact_button">
                      <span className="theme-icons">
                        <i className="bi bi-moon"></i>{" "}
                        Icon for dark mode
                      </span>
                    </Link>
                  )} */}
                  </div>
                )}
              </Toolbar>
            </AppBar>

            <Drawer
              anchor="left"
              open={mobileMenuOpen}
              onClose={handleMobileMenuClose}
              className={`mobile-drawer ${classes.drawer}`}
            >
              <div className={classes.mobileMenu}>
                <div className="logo_new_sectio mobile_menu_icon">
                  <Link to="/" className="logo-brand">
                    <img src={Logo} className="img-fluid" alt="logo" />
                  </Link>
                </div>

                <div className="menu_statis">
                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/home" : "/"}>Home</Link>
                  </ListItem>
                  {/* <ListItem button className="drawa">
                    {user.isAuthenticated ? (
                      <Link to={user.isAuthenticated ? "/strategies" : "/"}>
                        Strategies
                      </Link>
                    ) : (
                      <Link
                        onClick={walletneed}
                        to={user.isAuthenticated ? "/" : "/"}
                      >
                        Strategies
                      </Link>
                    )}
                  </ListItem> */}
                  <ListItem button className="drawa ">
                    <Link to={user.isAuthenticated ? "/assets" : "/"}>
                      Assets
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/deposit" : "/"}>
                      Deposit
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/transferwallet" : "/"}>
                      Transfer
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/upgrade" : "/"}>
                      Upgrade
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/strategies" : "/"}>
                      Strategies
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/apibind" : "/"}>
                      API Binding
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/bottradehistory" : "/"}>
                      Bot Trade
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/balance-history" : "/"}>
                      Bot Balance
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/withdraw" : "/"}>
                      Withdraw
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/referral" : "/"}>
                      {" "}
                      Refer & Earn
                    </Link>
                  </ListItem>

                  <ListItem button className="drawa">
                    <Link to={user.isAuthenticated ? "/team" : "/"}>
                      {" "}
                      Your Team
                    </Link>
                  </ListItem>

                  {user.isAuthenticated ? (
                    <>
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/profile" : "/"}>
                          {" "}
                          Profile
                        </Link>
                      </ListItem>
                      {/* <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/deposit" : "/"}>
                          {" "}
                          Deposit
                        </Link>
                      </ListItem> */}

                      {/* <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/apibind" : "/"}>
                          {" "}
                          API Bind
                        </Link>
                      </ListItem> */}
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/security" : "/"}>
                          {" "}
                          Security
                        </Link>
                      </ListItem>
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/faq" : "/"}>
                          {" "}
                          FAQs
                        </Link>
                      </ListItem>
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/policy" : "/"}>
                          {" "}
                          Policy
                        </Link>
                      </ListItem>
                      {/* <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/team" : "/"}>
                          Your Team
                        </Link>
                      </ListItem> */}
                      {/* <ListItem button className="drawa">
                        <Link
                          to={user.isAuthenticated ? "/transferwallet" : "/"}
                        >
                          Transfer
                        </Link>
                      </ListItem> */}
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/history" : "/"}>
                          {" "}
                          History
                        </Link>
                      </ListItem>
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/poolhistory" : "/"}>
                          {" "}
                          Pool
                        </Link>
                      </ListItem>
                      <ListItem button className="drawa">
                        <Link to={user.isAuthenticated ? "/support" : "/"}>
                          Support
                        </Link>
                      </ListItem>
                      <ListItem button className="drawa">
                        {!user.isAuthenticated ? (
                          <Link to="/login">
                            <button
                              className="head-btn-login now_log"
                              style={{ width: "150px" }}
                            >
                              <span className="head-btn-login-now now_log">
                                Login
                              </span>
                              <span className="head-btn-login-new">Login</span>
                            </button>
                          </Link>
                        ) : (
                          ""
                        )}
                      </ListItem>
                      <ListItem button className="drawa">
                        {!user.isAuthenticated ? (
                          <Link to="/register">
                            <button
                              className="head-btn-login"
                              style={{ width: "150px" }}
                            >
                              <span className="head-btn-login-now">
                                Register
                              </span>
                              <span className="head-btn-login-new">
                                Register
                              </span>
                            </button>
                          </Link>
                        ) : (
                          ""
                        )}
                      </ListItem>
                      <ListItem button className="drawa">
                        {user.isAuthenticated ? (
                          <Link>
                            <button
                              className="head-btn-login mx-2"
                              style={{ width: "150px" }}
                              onClick={handleLogout}
                            >
                              <span className="head-btn-login-now">Logout</span>
                              <span className="head-btn-login-new">Logout</span>
                            </button>
                          </Link>
                        ) : (
                          ""
                        )}
                      </ListItem>
                    </>
                  ) : (
                    ""
                  )}
                  {headerLoader == true ? (
                    ""
                  ) : !user.isAuthenticated ? (
                    <>
                      <Link to="/login">
                        <button
                          className="head-btn-login mx-2"
                          style={{ width: "150px" }}
                        >
                          <span className="head-btn-login-now">Login</span>
                          <span className="head-btn-login-new">Login</span>
                        </button>
                      </Link>
                      <Link to="/register">
                        <button
                          className="head-btn-login mt-2 mx-2"
                          style={{ width: "150px" }}
                        >
                          <span className="head-btn-login-now">Register</span>
                          <span className="head-btn-login-new">Register</span>
                        </button>
                      </Link>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </Drawer>

            {emailPopup && (
              <div
                className="modal fade show email_modal"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header lvl-one-header email_missing_header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Email Update
                      </h1>

                      <span className="btn-close-new" onClick={closePopup}>
                        X
                      </span>
                    </div>
                    <div className="modal-body personal_verify_body lvl-one-body email_missing_header">
                      <div className="mt-2 d-flex flex-column gap-3">
                        <div className="profile_edit_inpmain">
                          <span className="home-viewasset-span">
                            <h1 className="email_header">
                              Your email is missing
                            </h1>
                            <p>
                              We noticed that your email is missing from your
                              account. please update your email.
                            </p>
                            <p>
                              Click the button below to update your email
                              address:
                            </p>
                          </span>
                        </div>
                        <div className="update-email">
                          <button
                            className="btn profile_savebtn"
                            onClick={proceedToProfile}
                          >
                            Update Email
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {verifyEmailPopup && (
              <div
                className="modal fade show email_modal"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header lvl-one-header email_missing_header">
                      <h1 className="modal-title fs-5">Verify Your Email</h1>
                      <span
                        className="btn-close-new"
                        onClick={closeVerifyPopup}
                      >
                        X
                      </span>
                    </div>
                    <div className="modal-body personal_verify_body lvl-one-body email_missing_header">
                      <div className="mt-2 d-flex flex-column gap-3">
                        <div className="profile_edit_inpmain">
                          <span className="home-viewasset-span">
                            <h1 className="email_header">
                              Your email is not verified
                            </h1>
                            <p>
                              We noticed that your email is not verified in your
                              account. please verify your email.
                            </p>
                            <p>
                              Click the button below to verify your email
                              address:
                            </p>
                          </span>
                        </div>
                        <div className="update-email">
                          <button
                            className="btn profile_savebtn"
                            onClick={proceedToProfile}
                          >
                            Verify Email
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {notificationPopup && (
              <div
                className="modal fade show email_modal"
                style={{ display: "block" }}
                tabIndex="-1"
                role="dialog"
              >
                <div
                  className="modal-dialog modal-dialog-centered modal-md"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header lvl-one-header email_missing_header">
                      <h1 className="modal-title fs-5" id="exampleModalLabel">
                        Notification Update
                      </h1>

                      <span className="btn-close-new" onClick={close_popup}>
                        X
                      </span>
                    </div>
                    <div className="modal-body personal_verify_body lvl-one-body email_missing_header">
                      <div className="mt-2 d-flex flex-column gap-3">
                        <div className="profile_edit_inpmain">
                          <span className="home-viewasset-span">
                            <h1 className="email_header">
                              You got a new notification from Binarge
                            </h1>
                            <p>{AdminNotificationref.current.message}</p>
                          </span>
                        </div>
                        <div className="update-email">
                          <button
                            className="btn profile_savebtn"
                            onClick={close_popup}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <Joyride
              steps={steps}
              run={run}
              continuous={true}
              showProgress={true}
              showSkipButton={true}
              showBackButton={true}
              callback={(data) => {
                if (data.status === "finished" || data.status === "skipped") {
                  setRun(false);
                  localStorage.removeItem("userlogin"); // Remove first login flag

                  // **Step 3: Check Email Conditions After Joyride**
                  const userEmail = localStorage.getItem("useremail") || "";
                  const hasSeenEmailPopup =
                    localStorage.getItem("hasSeenEmailPopup");

                  if (!userEmail || userEmail === "N/A") {
                    setEmailPopup(true);
                    localStorage.setItem("hasSeenEmailPopup", "true"); // Mark email popup as seen
                  } else {
                    if (user.emailStatus == 0) {
                      localStorage.setItem("hasSeenEmailVerifyPopup", "false");
                      setVerifyEmailPopup(true);
                    }
                  }
                }
              }}
              locale={{
                last: "Done",
                next: "Next",
                back: "Back",
                skip: "Skip",
              }}
              styles={{
                options: {
                  zIndex: 1000,
                  primaryColor: "#007bff",
                  textColor: "#333",
                  overlayColor: "rgba(0, 0, 0, 0.5)",
                  backgroundColor: "#fff",
                  width: 400,
                },
                buttonSkip: {
                  backgroundColor: "transparent",
                  color: "rgb(206, 179, 8)",
                  fontWeight: "bold",
                  fontSize: "14px",
                  border: "none",
                  padding: "6px 12px",
                },
                buttonNext: {
                  backgroundColor: "#fff",
                  color: "#000",
                  borderRadius: "5px",
                  fontSize: "14px",
                  padding: "8px 10px",
                  border: "1px solid #ccc",
                },
                buttonBack: {
                  backgroundColor: "transparent",
                  color: "rgb(206, 179, 8)",
                  fontWeight: "bold",
                  border: "none",
                  padding: "6px 12px",
                  fontSize: "14px",
                },
                tooltip: {
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                },
                tooltipFooter: {
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                },
                buttonClose: {
                  color: "#eaecef",
                },
              }}
            />
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
